export const UI_TYPE_DEFAULT = 'DEFAULT';
export const UI_TYPE_HERO = 'HERO';
export const UI_TYPE_PARENT = 'PARENT';
export const UI_TYPE_LOOK = 'LOOK';
export const COLLECTION_TYPE_VARIANTS = 'product_variants';
export const COLLECTION_TYPE_BRANDS = 'brands';